import { SkeletonBlock } from '../../SkeletonBlock/SkeletonBlock';
import { SkeletonCard } from '../common';

export function SecondBlock() {
  return (
    <SkeletonCard className="h-[212px] rounded-[16px] px-0">
      <div className="px-[16px]">
        <SkeletonBlock className="h-[16px] w-[clamp(119px,30%,240px)]" variant="sunked" />
      </div>
      <div className="mt-[26px] px-[24px] grid grid-cols-3 gap-x-[24px]">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="flex flex-col items-center gap-[8px]">
            <SkeletonBlock className="w-[67px] h-[67px]" variant="sunked" />
            <SkeletonBlock className="w-full h-[16px]" variant="sunked" />
            <SkeletonBlock className="w-full h-[16px]" variant="sunked" />
          </div>
        ))}
      </div>
    </SkeletonCard>
  );
}
